import { Text } from "@chakra-ui/react";
import introImg from "public/pocCloud/emulate-simulate.png";
import { TEXT_VARIANTS } from "@/theme/components/text";

export const INTRO_CONSTANTS = {
  title: "Emulation, Simulation & Real-World Testing — Smarter Validation at Every Stage",
  description: [
    "At OneMind, testing isn’t an afterthought—it’s a strategic foundation. We provide a virtual-first, fully managed environment where teams can emulate systems, simulate conditions, and conduct real-world testing—all without the burden of physical infrastructure.",
    "Our approach enables faster innovation, reduced risk, and confident decision-making across every phase of your IT lifecycle.",
  ],
  points: [
    "Emulation : Replicate system or network behavior with precision using cloud-hosted environments—ideal for protocol testing, integration validation, and architecture exploration without the hardware.",
    "Simulation : Model complex scenarios to predict system response, optimize configurations, and plan for scale—all within a controlled, cost-effective digital space.",
    "Real-World Testing : Validate performance, scalability, and stability under live operational conditions—ensuring your solutions are ready for deployment.",
  ],
  children: (
    <Text color="text.100" variant={TEXT_VARIANTS.BODY2}>
      Whether you&apos;re testing new architectures, developing POCs, or training teams,
      OneMind delivers everything you need—virtualized, managed, and built for what’s
      next.{" "}
    </Text>
  ),
  image: introImg,
};
